import { Card } from "@/components/ui/card";
import useDocumentTitle from "@/components/ui/common/document-title";
import ProductsTableView from "./table";

const Products = () => {
  useDocumentTitle("Products");

  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <ProductsTableView/>
      </Card>
    </div>
  );
};

export default Products;
